export default ({
  searchType,
}) => {
  const searchTypeUpperCase = typeof searchType === 'string' ? searchType.toUpperCase() : searchType;
  const searchTypeText = searchTypeUpperCase === 'H' ? 'application' : 'search';

  return `Personal details relating to this ${searchTypeText}`;
};
